module.exports = __webpack_public_path__ + "static/img/8.fe8f645.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/8.png
// module id = aFBi
// module chunks = 0